<syslink-grid
  #grid
  [gridName]="storageKey"
  [canView]="canView"
  [canSearch]="canSearch"
  [canRefresh]="canRefresh"
  [canAdd]="canAdd"
  [canSort]="canSort"
  [canUpdate]="canUpdate"
  [canDelete]="canDelete"
  [canFilter]="canFilter"
  [canExport]="canExport"
  [canDblClck]="canDblClck"
  key="Oid"
  [service]="usersService"
  [columns]="columns"
  [filter]="filter"
  [storageKey]="storageKey"
  (add)="onAddButtonClicked()"
  (beforeDelete)="onDeleteClicked($event)"
  (doubleClick)="onDoubleClicked($event)"
></syslink-grid>
